import { downloadEducationRecordAttachment } from '../../../api/education';
import {
  EducationRecord,
  parseEducationAttendees,
} from '../../../types/education';
import ApprovalStampBox from '../ApprovalStampBox';
import SignaturePadField from '../../common/SignaturePadField';
import '../../quality/EducationAnnualPlanTab.css';
import '../../quality/QualityShell.css';
import '../../quality/CleanActivityPanel.css';
import '../../product/InspectionFormSheet.css';
import '../../product/NonconformanceReportPanel.css';
import { PreviewAttachmentList } from './previewShared';

interface Props {
  detail: EducationRecord;
}

function EducationRecordPreviewView({ detail }: Props) {
  const attendees = parseEducationAttendees(detail.attendees);

  return (
    <div className="quality-form">
      <section className="quality-form__section">
        <div
          style={{
            display: 'flex',
            justifyContent: 'space-between',
            gap: 16,
            alignItems: 'flex-start',
            marginBottom: 12,
          }}
        >
          <h3 style={{ margin: 0 }}>교육 기록</h3>
          <ApprovalStampBox
            authorName={detail.authorName}
            reviewerName={detail.reviewerName}
            approverName={detail.approverName}
          />
        </div>
        <div className="quality-form__grid">
          <label>
            문서번호
            <input value={detail.recordNo || ''} disabled />
          </label>
          <label>
            교육일
            <input type="date" value={detail.educationDate || ''} disabled />
          </label>
          <label>
            시작 시간
            <input type="time" value={detail.startTime?.slice(0, 5) || ''} disabled />
          </label>
          <label>
            종료 시간
            <input type="time" value={detail.endTime?.slice(0, 5) || ''} disabled />
          </label>
          <label className="is-span-2">
            교육명 *
            <input value={detail.title || ''} disabled />
          </label>
          <label>
            구분
            <select value={detail.educationType || 'INTERNAL'} disabled>
              <option value="INTERNAL">사내</option>
              <option value="EXTERNAL">사외</option>
            </select>
          </label>
          <label>
            강사
            <input value={detail.instructor || ''} disabled />
          </label>
          <label>
            장소
            <input value={detail.place || ''} disabled />
          </label>
          <label>
            이수시간
            <input value={detail.hours || ''} disabled />
          </label>
        </div>
      </section>

      <section className="quality-form__section">
        <div className="quality-form__grid">
          <label className="is-span-2">
            교육내용
            <textarea rows={4} value={detail.content || ''} disabled />
          </label>
          <label className="is-span-2">
            교육결과
            <textarea rows={3} value={detail.resultText || ''} disabled />
          </label>
          <label className="is-span-2">
            비고
            <textarea rows={2} value={detail.remark || ''} disabled />
          </label>
        </div>
      </section>

      <section className="quality-form__section">
        <div className="edu-plan-card__title" style={{ marginBottom: 8 }}>
          <h3 style={{ margin: 0 }}>첨부파일</h3>
        </div>
        <p className="edu-plan-hint">출석부, 교육자료, 평가결과 등을 첨부할 수 있습니다.</p>
        <PreviewAttachmentList
          files={detail.attachments}
          onDownload={(file) => {
            void downloadEducationRecordAttachment(
              detail.recordId,
              file.attachmentId,
              file.fileName
            );
          }}
        />
      </section>

      <section className="quality-form__section">
        <div className="ca-section-head">
          <h3>참석자</h3>
        </div>
        <div className="ca-items">
          {attendees.map((row, idx) => (
            <div className="ca-item-card" key={row.id}>
              <div className="ca-item-card__head">
                <strong>참석자 {idx + 1}</strong>
              </div>
              <div className="ca-item-card__grid">
                <label className="is-wide">
                  부서
                  <input readOnly value={row.dept || ''} />
                </label>
                <label className="is-wide">
                  성명
                  <input readOnly value={row.name || ''} />
                </label>
                <div className="is-full">
                  <SignaturePadField value={row.signatureData} disabled />
                </div>
              </div>
            </div>
          ))}
        </div>
      </section>
    </div>
  );
}

export default EducationRecordPreviewView;
